import React from 'react';
import { Box, Checkbox, FormControlLabel, Grid, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import type { AgentConfigurationCardProps } from '../../../../types/features/storeDetails/agentConfigurationCard';
import {
  adminCheckboxSx,
  adminFieldLabelSx,
  adminInlineControlLabelSx,
} from '../../../../styles/adminComponentStyles';

type AgentConfigurationExtensionsProps = Pick<
  AgentConfigurationCardProps,
  'availableExtensions' | 'control' | 'checkboxIcon' | 'checkboxCheckedIcon'
>;

const AgentConfigurationExtensions: React.FC<AgentConfigurationExtensionsProps> = ({
  availableExtensions,
  control,
  checkboxIcon,
  checkboxCheckedIcon,
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ ...adminFieldLabelSx, display: 'block', mb: 1 }}>
        Extensions Enabled
      </Typography>
      <Grid container spacing={2}>
        {availableExtensions.map((ext) => (
          <Grid size={{ xs: 6, sm: 4, md: 2.4 }} key={ext}>
            <Controller
              name="posConfig.EligibleExtensions"
              control={control}
              render={({ field }) => {
                const selected: string[] = Array.isArray(field.value) ? (field.value.filter(Boolean) as string[]) : [];
                const checked = selected.includes(ext);
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={checked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            field.onChange([...selected, ext]);
                          } else {
                            field.onChange(selected.filter((s) => s !== ext));
                          }
                        }}
                        icon={checkboxIcon}
                        checkedIcon={checkboxCheckedIcon}
                        sx={adminCheckboxSx}
                      />
                    }
                    label={ext}
                    sx={adminInlineControlLabelSx}
                  />
                );
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default React.memo(AgentConfigurationExtensions);
